import React, { useEffect, useRef } from "react";
import { VideoWidget1 } from "@/components/PagePiller/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import SectionHeader from "@/components/SectionHeader";
import IconPlus from "$/icons/icon-plus.svg";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import styles from "./VideoWidget.module.scss";

interface VideoWidgetProps {
  data: VideoWidget1;
  userAgent: DeviceInfo;
  registerRef?: RegisterRefType;
  elementRefs?: any;
}

const VideoWidgetComponent: React.FC<VideoWidgetProps> = ({ data, registerRef, userAgent }) => {
  const { Heading: title, ShortDescription: description, DynamicVideos: videos } = data;
  const video = videos?.[0];

  const videoElementRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry: any) => {
          if (!entry.isIntersecting) {
            // Pause the video if it's out of the screen
            videoElementRef.current?.pause();
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    /** May need for future to make section base **/
    // const vsection = videoSectionRef?.current || elementRefs?.current?.[data?.refId];
    const vsection = videoElementRef?.current;

    if (vsection) {
      observer.observe(vsection);
    }

    return () => {
      if (vsection) {
        observer.unobserve(vsection);
      }
    };
  }, []);

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) {
          registerRef(data?.refId, el);
        }
      }}
      className={`${styles.container} container scrollMargin spacingBetweenSections`}
    >
      {title && (
        <SectionHeader
          userAgent={userAgent}
          title={title}
          subTitle={description}
          desktopAlignLeft
          className={styles.sectionHeader}
        />
      )}
      {video?.Video?.data?.attributes?.url && (
        <div className={styles.videoWrapper}>
          <video
            poster={video?.Thumbnail?.data?.attributes?.url}
            src={video?.Video?.data?.attributes?.url}
            autoPlay={false}
            controls
            muted
            preload={"metadata"}
            playsInline
            ref={videoElementRef}
            width={"100%"}
            height={200}
          />
        </div>
      )}
      {!!video?.Tags?.length && (
        <div className={styles.videoTags}>
          {video?.Tags?.map(({ id, TagName: name }) => {
            return <span key={id}>{name}</span>;
          })}
        </div>
      )}
      {video?.Title && <div className={styles.videoTitle} dangerouslySetInnerHTML={{ __html: video?.Title }} />}
      {video?.AuthorName && (
        <div className={styles.author}>
          <IconPlus width={20} height={20} />
          {video?.AuthorName}
        </div>
      )}
    </section>
  );
};

export default VideoWidgetComponent;
